import React, { useEffect } from "react";

const RedirectPage = () => {
	useEffect(() => {
		// Redirecionamento
		window.location.replace("https://graduacao.feevale.br/cursos/medicina");
	}, []);

	return <></>;
};

export default RedirectPage;
